// extracted by mini-css-extract-plugin
export default {"game_share_toast":"index_game_share_toast__bb26V","mask":"index_mask__CZjr6","share":"index_share__ocDEI","share-boby":"index_share-boby__OJFJi"};